import { Controller } from "@hotwired/stimulus"
import { put }  from "@rails/request.js"

export default class extends Controller {
  static targets = [ "counter" ]

  connect() {
    console.log("UpdateAssuntosController connected")
    this.updateCounter()
  }

  async toggle(ev) {
    const checkbox = ev.target
    const assuntoId = checkbox.value
    const checked = checkbox.checked
    const url = `${this.data.get('url')}/${assuntoId}`

    this.displayLoading(assuntoId);
    const response = await put(url, { body: JSON.stringify({ checked: checked }) })
    if (response.ok) {
      this.updateCounter(checked ? 1 : -1)
      this.displaySuccess(assuntoId)
    } else {
      this.displayFailed(assuntoId)
      checkbox.checked = !checked
    }
  }

  displayLoading(assuntoId) {
    const element = document.getElementById(`resultado_${assuntoId}`)
    const loadingImageTag = `<img src="${this.data.get('spinnerUrl')}"></img>`
    element.innerHTML = loadingImageTag
  }

  displaySuccess(assuntoId) {
    const element = document.getElementById(`resultado_${assuntoId}`)
    element.innerHTML = '<i class="fas fa-check text-success"></i>'
    setTimeout(() => { element.innerHTML = '' }, 1000)
  }

  displayFailed(assuntoId) {
    const element = document.getElementById(`resultado_${assuntoId}`)
    element.innerHTML = '<i class="fas fa-times text-danger"></i>'
  }

  updateCounter(increment = 0) {
    this.data.set('quantAssuntosSelecionados', this.quantAssuntosSelecionados + increment)
    const css = (this.quantAssuntosSelecionados == 0) ? 'secondary' : 'success'
    this.counterTarget.innerHTML = `<span class="badge badge-${css}">${this.quantAssuntosSelecionados} / ${this.totalAssuntos}</span>`
  }

  get quantAssuntosSelecionados() {
    return parseInt(this.data.get('quantAssuntosSelecionados'))
  }

  get totalAssuntos() {
    return parseInt(this.data.get('total-assuntos'))
  }


}
